import { AbstractControl, ValidatorFn } from '@angular/forms';

export function largerThenDateValidator(largerThenDateControl: () => AbstractControl): ValidatorFn {
  return (control: AbstractControl): { [key: string]: any } | null => {
    // Do not check if the formGroup has not been initialized yet
    if (!control.parent) {
      return null;
    }

    const otherControl = largerThenDateControl();

    if (control.value && otherControl.value && new Date(control.value) < new Date(otherControl.value)) {
      return { largerThenDate: true };
    }

    return null;
  };
}
